// extracted by mini-css-extract-plugin
export default {"card":"index_card__6I7wI","empty":"index_empty__uu4se","emptytext":"index_emptytext__6htgO"};